import directive from './src/directive';
import service from './src/index';

export default {
  install(Vue) {
    Vue.use(directive);
    Vue.prototype.$snloading = service;
  },
  directive,
  service
};



// WEBPACK FOOTER //
// ./src/components/loading/index.js